import React, { useState } from "react";
import Container from "@mui/material/Container";
import {
	AppBar,
	Avatar,
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CssBaseline,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Stack,
	TextField,
	ThemeProvider,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { relative } from "path";
import logo from "../assets/logo.png";
import image1 from "../assets/image_1.png";
import image2 from "../assets/image_2.png";
import { useAuth } from "../providers/AuthenticationProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


export const Dashboard = () => {
	const { traderProfile, profile } = useAuth();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const handleDownload = () => {
		const fileUrl = "../xsee_copier.ex4";

		const downloadLink = document.createElement("a");

		downloadLink.href = fileUrl;

		downloadLink.download = "xsee_copier.ex4";

		document.body.appendChild(downloadLink);

		downloadLink.click();

		document.body.removeChild(downloadLink);
	};
	const handleDownloadEX5 = () => {
		const fileUrl = "../Xsee5.ex4";

		const downloadLink = document.createElement("a");

		downloadLink.href = fileUrl;

		downloadLink.download = "Xsee5.ex4";

		document.body.appendChild(downloadLink);

		downloadLink.click();

		document.body.removeChild(downloadLink);
	};
	return (
		<Container>
			<Box
				sx={{
					marginTop: "8vh",
					padding: "4vh",
				}}
			>
				<Stack spacing={2}>
					<Box
						sx={{
							backgroundSize: "cover",
							borderRadius: "8px",
							backgroundPosition: "center",
							width: "100%",
							backgroundColor: "#147A7A",
							padding: "4vh 20px",
						}}
					>
						<Typography
							variant="h4"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "bold",
								fontSize:
									window.innerWidth < 600 ? "24px" : "28px",
							}}
						>
							{t("dashboard.are_you_a_trader")}
						</Typography>
						<Typography
							sx={{
								fontFamily: "Work Sans !important",
							}}
						>
							{t("dashboard.become_partner")}
						</Typography>
					</Box>

					<Box>
						<h3>{t("dashboard.how_to_join")}</h3>
						<p>{t("dashboard.join_description")}</p>
						<ul>
							<li>
								<strong>{t("dashboard.sign_up")}</strong>:{" "}
								{t("dashboard.sign_up_description")}
							</li>
							<li>
								<strong>
									{t("dashboard.confirm_account")}
								</strong>
								: {t("dashboard.confirm_account_description")}
								<a
									href="mailto:info@xseetrading.com"
									style={{ color: "#147A7A" }}
								>
									<b>info@xseetrading.com</b>
								</a>{" "}
								{t("dashboard.to_obtain")}.
							</li>
						</ul>
					</Box>

					<Box
						sx={{
							backgroundSize: "cover",
							borderRadius: "8px",
							backgroundPosition: "center",
							width: "100%",
							backgroundColor: "#232839",
							padding: "4vh 20px",
						}}
					>
						<Grid container>
							<Grid xs={12} sm={8}>
								<Typography
									variant="h4"
									sx={{
										fontFamily: "Work Sans !important",
										fontWeight: "bold",
										fontSize:
											window.innerWidth < 600
												? "24px"
												: "28px",
									}}
								>
									{t("dashboard.download_advisor")}
								</Typography>
								<Typography
									sx={{
										fontFamily: "Work Sans !important",
									}}
								>
									{t(
										"dashboard.download_advisor_description"
									)}
								</Typography>

								<Button
									onClick={() => handleDownload()}
									variant="contained"
									color="secondary"
									sx={{
										marginTop: "16px",
										fontWeight: "bold",
									}}
								>
									{t("dashboard.download_ex4")}
								</Button>
								<Button
									onClick={() => handleDownloadEX5()}
									variant="contained"
									color="secondary"
									sx={{
										marginTop: "16px",
										marginLeft: { xs: "0", sm: "16px" },
										fontWeight: "bold",
									}}
								>
									{t("dashboard.download_ex5")}
								</Button>
							</Grid>

							<Grid xs={0} sm={4}></Grid>
						</Grid>
					</Box>
					<Box>
						<h3>{t("dashboard.ea_installation")}</h3>
						<p>{t("dashboard.ea_installation_description")}</p>
						<ol>
							<li>
								<strong>{t("dashboard.ea_step_1")}</strong>:{" "}
								{t("dashboard.ea_step_1_description_1")}{" "}
								<b>xsee_copier.ex4</b>{" "}
								{t("dashboard.ea_step_1_description_2")}
							</li>
							<li>
								<strong> {t("dashboard.ea_step_2")}</strong>:{" "}
								{t("dashboard.ea_step_2_description_login")}{" "}
								<b>trade id</b>{" "}
								{t("dashboard.ea_step_2_description_and_your")}{" "}
								<b>token</b>.<br></br>
								<img
									src={image1}
									style={{
										maxWidth: "520px",
										width: "100%",
										margin: "12px 0",
									}}
								></img>
							</li>
							<li>
								<strong>{t("dashboard.ea_step_3")}</strong>:{" "}
								{t("dashboard.ea_step_3_description_copy")}{" "}
								<b>
									{t(
										"dashboard.ea_step_3_description_API_URL"
									)}
								</b>{" "}
								in{" "}
								<b>
									<i>
										{t(
											"dashboard.ea_step_3_description_copy_path"
										)}
									</i>
								</b>
								<br></br>
								<img
									src={image2}
									style={{
										maxWidth: "520px",
										width: "100%",
										margin: "12px 0",
									}}
								></img>
							</li>
							<li>
								<b>{t("dashboard.ea_step_4")}</b>
							</li>
						</ol>
						{traderProfile != null && (
							<>
								<Button
									variant="text"
									color="secondary"
									sx={{
										textTransform: "none",
										fontFamily: "Work Sans !important",
									}}
									onClick={() => {
										navigate("/trader/profile");
									}}
								>
									{t("dashboard.go_to_dashboard")}
								</Button>
							</>
						)}
						{profile != null &&
							(profile.role == "Affiliate" ||
								profile.role == "AffiliateMaster") && (
								<>
									<Button
										variant="text"
										color="secondary"
										sx={{
											textTransform: "none",
											fontFamily: "Work Sans !important",
										}}
										onClick={() => {
											navigate("/affiliate/dashboard");
										}}
									>
										{t(
											"dashboard.go_to_affiliate_dashboard"
										)}
									</Button>
								</>
							)}
					</Box>
				</Stack>
			</Box>
			<Box
				sx={{
					padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
				}}
			>
				<Container>
					<Grid container spacing={2}>
						<Grid md={2} xs={0}></Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("terms-condition")}
								target="_blank"
							>
								{t("footer.termsOfUse")}
							</a>
						</Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("privacy-policy")}
								target="_blank"
							>
								{t("footer.privacyPolicy")}
							</a>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</Container>
	);
};
